var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCountryFlagVietnamsvgrIcon = function SvgCountryFlagVietnamsvgrIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 32 32",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#country-flag-vietnam_svgrIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E54133",
    d: "M29.612 0H2.394C1.075 0 0 1.631 0 3.654v24.692C0 30.369 1.075 32 2.394 32h27.212C30.93 32 32 30.359 32 28.346V3.654C32.006 1.631 30.931 0 29.612 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE15A",
    d: "m16.259 9.523 1.475 4.503 4.663.039c.263 0 .37.343.157.496l-3.751 2.817 1.407 4.523c.08.254-.207.464-.42.305l-3.787-2.754-3.795 2.76c-.213.153-.494-.057-.419-.305l1.407-4.522-3.751-2.818c-.213-.159-.1-.496.156-.496l4.664-.038 1.475-4.504c.088-.26.437-.26.519-.006"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    x: 1,
    y: 1,
    stroke: "currentColor",
    strokeWidth: 2,
    rx: 15
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "country-flag-vietnam_svgrIcon_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#fff",
    rx: 16
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCountryFlagVietnamsvgrIcon);
export default ForwardRef;